import get from "lodash/get";
import { action, computed, observable, toJS } from "mobx";
import { opinionQuestions } from "../assess/question";
import { getTopStage } from "../assess/survey-utils";
import storage from "../storage";
import { firebase } from "./../constants";
import { authStore } from "./../stores";

class ResultStore {
  @observable noChurchData = false;
  @observable churchData = null;
  @observable churchResponse = null;
  @observable localResponse = null;
  @observable generatingPDF = false;

  @computed
  get averageResponse() {
    if (this.churchResponse) {
      var responses = this.churchResponse;
      var numResponses = Object.keys(responses).length;
      var averageResponse = toJS(responses.initial);
      var qs = averageResponse.surveyData.questions;
      qs.forEach((x) => (x.value = x.value || 0));
      Object.values(responses).forEach((r) => {
        if (r == responses.initial) return;
        r.surveyData.questions.forEach((q, i) => {
          qs[i].value += q.value || 0;
        });
      });
      qs.forEach((q) => (q.value /= numResponses));
      return averageResponse;
    }
  }
  @computed
  get lifecycleSide() {
    if (this.churchData && this.averageResponse) {
      if (
        this.churchData.attendanceOne &&
        this.churchData.attendanceTwo &&
        this.churchData.conversions
      ) {
        const attendanceGrowth =
          Number(this.churchData.attendanceOne) -
          Number(this.churchData.attendanceTwo);
        const percentConversionsGrowth =
          Number(this.churchData.conversions) /
          Number(this.churchData.attendanceOne);
        if (attendanceGrowth > 0 && percentConversionsGrowth >= 0.06) {
          return "left";
        }
        return "right";
      } else if (this.churchData.conversions && this.churchData.attendanceAvg) {
        // if we don't have specific yearly attendance numbers,
        // we need to take a sample from the average and then do the
        // conversions/attendance ratio calculation from that.
        const sampleAttendance = {
          "Under 200": 100,
          "200-499": 300,
          "500-999": 750,
          "1,000-4,999": 1000,
          "5,000+": 5000,
        }[this.churchData.attendanceAvg];
        if (sampleAttendance) {
          const percentConversionsGrowth =
            Number(this.churchData.conversions) / Number(sampleAttendance);
          if (percentConversionsGrowth >= 0.06) {
            return "left";
          }
          return "right";
        }
      }
    }
  }
  @computed
  get responses() {
    let questions;
    if (this.averageResponse) {
      questions = this.averageResponse.surveyData.questions;
    } else if (this.localResponse) {
      questions = this.localResponse.surveyData.questions;
    }
    if (questions) {
      return questions.sort((a, b) => a.id - b.id).map((q) => q.value);
    }
  }
  @computed
  get phase() {
    if (this.averageResponse) {
      return getTopStage(this.responses, this.lifecycleSide);
    } else {
      return getTopStage(this.responses);
    }
  }

  @action.bound
  takeAgain() {
    if (authStore.auth && authStore.auth.uid) {
      var oldKey = "archived" + Date.now();
      firebase
        .database()
        .ref(`church/${authStore.auth.uid}`)
        .once(
          "value",
          action((snapshot) => {
            const church = snapshot.val();
            firebase
              .database()
              .ref(`church/${authStore.auth.uid}`)
              .update({ [oldKey]: church, churchData: null, responses: null })
              .then(
                action((x) => {
                  this.reset();
                  this.noChurchData = true;
                })
              );
          })
        );
    }
  }
  @action.bound
  setLocalResponse(localResponse) {
    this.localResponse = localResponse;
    storage.set("localResponse", JSON.stringify(localResponse));
  }
  @action.bound
  loadChurchResponse() {
    if (authStore.auth && authStore.auth.uid) {
      firebase
        .database()
        .ref(`church/${authStore.auth.uid}`)
        .once(
          "value",
          action((snapshot) => {
            const church = snapshot.val();
            if (church && church.churchData && church.responses) {
              this.churchData = church.churchData;
              this.churchResponse = church.responses;
              storage.remove("localResponse");
            }

            if (!church.churchData) {
              this.noChurchData = true;
            }
          })
        );
    }
  }
  @action.bound
  createResultsPDF() {
    const questions = toJS(this.averageResponse || this.localResponse);
    if (questions) {
      this.generatingPDF = true;
      setTimeout(
        action(() => {
          const callback = action(() => {
            this.generatingPDF = false;
          });
          const isAverages = !!this.averageResponse;
          window.createResultsPDF(
            this.phase.stage,
            questions,
            opinionQuestions,
            isAverages,
            callback
          );
        }),
        0
      );
    }
  }
  @action.bound
  beginSubmit() {
    this.noChurchData = false;
  }
  @action.bound
  resetChurch() {
    this.churchData = null;
    this.churchResponse = null;
    this.noChurchData = false;
  }
  @action.bound
  reset() {
    this.churchData = null;
    this.churchResponse = null;
    this.localResponse = null;
    this.noChurchData = false;
    storage.remove("localResponse");
  }
  @action.bound
  init() {
    const localResponse = storage.get("localResponse");
    if (localResponse) {
      this.localResponse = JSON.parse(localResponse);
    }
  }
}

export default new ResultStore();



// WEBPACK FOOTER //
// ./src/result/result-store.js